export const SSNorITINFieldData = {
  formControlName: 'ssnOrItin',
  id: 'grit-ssn-or-itin',
  type: 'text',
  mask: 'ssn',
  label: 'SSN / ITIN',

  validationList: [
    {
      errorKey: 'pattern',
      args: ['^[(?!.*000)0-9]{3}-?(?!.*00)[0-9]{2}-?(?!.*666.*|0000)[0-9]{4}$'],
      message: 'Please add a valid SSN / ITIN.',
    },
  ],

  hint: 'This helps us verify your identity and keep your account safe.',

  prefixIcon: {
    iconName: 'security',
  },
  placeholder: '888-88-8888',

  requiredMessage: 'Your SSN / ITIN number should contain 9 digits.',
  visibilityCanToggle: true,
};
